import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Upload from './pages/Upload'
import Queue from './pages/Queue'
import JobResultPage from './pages/JobResult'
import VATChartPage from './pages/VATChart'

function AppRoutes() {
  const { isLoggedIn, login } = useAuth()

  if (!isLoggedIn) {
    return <Login onSuccess={login} />
  }

  return (
    <Layout>
      <Routes>
        <Route path="/"          element={<Dashboard />} />
        <Route path="/upload"    element={<Upload />} />
        <Route path="/queue"     element={<Queue />} />
        <Route path="/queue/:id" element={<JobResultPage />} />
        <Route path="/vat-chart" element={<VATChartPage />} />
        <Route path="*"          element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  )
}
